<div class="seperator"></div>
<div class="title" mat-dialog-title>Add Email and Password</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your Lifesight support to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Enter Lifesight Client Email" formControlName="email" data-cy="lifesight-client-email-input">
                <mat-error
                    *ngIf="connectionForm.get('email').errors && (connectionForm.get('email').touched || connectionForm.get('email').dirty)">
                    Invalid Email</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Password</mat-label>
                <input type="password" matInput placeholder="Enter Lifesight Password" formControlName="password" data-cy="lifesight-password-input">
                <mat-error
                    *ngIf="connectionForm.get('password').errors && (connectionForm.get('password').touched || connectionForm.get('password').dirty)">
                    Invalid Client Secret</mat-error>
            </mat-form-field>

            <!-- <mat-form-field class="name-select" appearance="outline" class="form-field">
                <mat-label>Currency</mat-label>
                <mat-select required="true" formControlName="currency" placeholder="Enter Currency">
                    <mat-option *ngFor="let currency of currencies" [value]="currency.name">
                       {{currency.name}} - {{currency.symbol}} 
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="name-select" appearance="outline" class="form-field">
                <mat-label>Timezone</mat-label>
                <mat-select required="true" formControlName="timezone" placeholder="Enter Timezone">
                    <mat-option *ngFor="let timezone of timezones" [value]="timezone">
                        {{timezone}}
                    </mat-option>
                </mat-select>
            </mat-form-field> -->
        </form>
        <div class="template">
            <a href="https://rubii-images.s3.ap-southeast-2.amazonaws.com/templates/lifesight.xlsx"
                target="_blank" data-cy="lifesight-template-link">Download a sample report</a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="lifesight-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>
